import { render } from "./PopUpRemove.vue?vue&type=template&id=692fc7a1"
import script from "./PopUpRemove.vue?vue&type=script&lang=js"
export * from "./PopUpRemove.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__